// extracted by mini-css-extract-plugin
export var button = "_8s-0";
export var icon = "_8s-1";